import { useState, useEffect } from "react";
import { BuzerIcon } from "../../../BuzerIcons";

// Round complete-toggle used in the trailing slot of habit/task rows. Empty at
// rest; commits to green success on hover/done. v2 — optimistic: it flips to the
// filled state immediately on tap (so mobile doesn't linger on the outlined
// :hover state while the async toggle + reload lands), then follows the prop.
// optimistic={false} — pre prípady, keď klik NIE je dokončenie (napr. súťaž len
// otvorí modal na zápis výsledku): fajka sa nesmie „predbežne" zobraziť, inak by
// ostala visieť, keď výsledok nezadáš (done sa nezmení → reconcile efekt nebeží).
// v33c — „viackrát za deň": keď je `steps > 1`, fajka sa napĺňa postupne ako voda (výška hladiny =
// reps/per_day). Ťuk optimisticky zdvihne hladinu o 1/steps; na poslednom kroku sa návyk splní
// (prop `done` prepne na plnú fajku). Bežné (steps ≤ 1) sa správajú ako doteraz.
export function CheckButton({ done = false, fill, steps = 1, onClick, style, optimistic = true, "aria-label": ariaLabel = "Splniť" }) {
  const partial = steps > 1;
  const [optim, setOptim] = useState(null);
  const [optimFill, setOptimFill] = useState(null);
  useEffect(() => { setOptim(null); setOptimFill(null); }, [done, fill]);  // reconcile on server state
  const shown = optim != null ? optim : done;
  const level = optimFill != null ? optimFill : Math.max(0, Math.min(1, fill || 0));
  return (
    <button type="button" aria-label={ariaLabel} aria-pressed={shown} style={style}
      onClick={(e) => {
        if (partial && !shown) setOptimFill(Math.min(1, (fill || 0) + 1 / steps));  // voda stúpne hneď
        else if (optimistic && !shown) setOptim(true);
        onClick && onClick(e);
      }}
      className={`bz-check${shown ? " bz-check--done" : ""}${partial && !shown && level > 0 ? " bz-check--filling" : ""}`}>
      {partial && !shown && level > 0 && <span className="bz-check__water" style={{ height: `${Math.round(level * 100)}%` }} />}
      {shown && <BuzerIcon name="check" size={17} color="currentColor" strokeWidth={2.4} />}
    </button>
  );
}
